import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomLoader from '../../common/CustomLoader';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';

export default class CustomCSSForm extends Component {
  static propTypes = {
    content: PropTypes.object,
  };

  handleCustomCSSSubmit = (values) => {
    this.props.handleCustomCSSSubmit(values);
  };

  render() {
    const { content, showCustomCSSLoader, togglestate } = this.props;
    let customCSS = content && content.customCSS ? content.customCSS : '';

    return (
      <>
        <Formik
          initialValues={{ customCSS }}
          enableReinitialize={true}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleCustomCSSSubmit(values);
            setSubmitting(false);
            resetForm({ values: { customCSS: '' } });
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors, values }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <AceEditor
                        mode="css"
                        theme="github"
                        name="customCSS"
                        value={values.customCSS}
                        onChange={(value) => setFieldValue('customCSS', value)}
                        onBlur={() => setFieldTouched('customCSS', true)}
                        rows={10}
                        fontSize={16}
                        showPrintMargin={false}
                        width="100%"
                        height={togglestate ? '75vh' : '300px'}
                        placeholder={`Insert your CSS here..`}
                      />
                      <ErrorMessage name="customCSS">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 text-right">
                    {content && content.customCSS ? (
                      <button
                        type="reset"
                        className="btn btn-default btn-md"
                        onClick={() => {
                          resetForm({ values: { customCSS: '' } });
                          setFieldValue('customCSS', '');
                        }}
                      >
                        <span>
                          <i className={`wb ${drapcodeIcon('eraser')}`}></i>&nbsp;Reset
                        </span>
                      </button>
                    ) : (
                      ''
                    )}
                    &nbsp;
                    {!(content && content.customCSS) ? (
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={isSubmitting && showCustomCSSLoader ? 'disabled' : ''}
                        title="Add Custom CSS"
                      >
                        <i className={`wb ${drapcodeIcon('create')}`}></i>&nbsp;Add
                        <CustomLoader loading={showCustomCSSLoader} />
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={isSubmitting && showCustomCSSLoader ? 'disabled' : ''}
                        title="Update Custom CSS"
                      >
                        <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update
                        <CustomLoader loading={showCustomCSSLoader} />
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  }
}
